import Icon from 'vue-awesome/components/Icon'

Icon.register({
  local_drink: {
    paths: [
      {
        d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z'
      }
    ],
    width: '24',
    height: '24'
  }
})
